export interface EmployeeDetailsResponse {
  employeeId: string;
  email: string;
  employeeName: string;
  jobRole: string;
  location: string;
  totalExperience: number;
  cbreExperience: number;
  dateOfJoining: string;
  lob: string;
  reportsTo: string;
  l3Leader: string[] | string;
  project: string;
  criticalResource: string;
  lastSpotAward: string;
  midYearFeedback: string;
  awards: number;
  primarySkills: string;
  secondarySkills: string;
  certifications: string;
}

export interface ProfileItemConfig {
  label: string;
  value: string;
}

export interface ProfileSectionConfig {
  about: ProfileItemConfig[];
  teamInfo: ProfileItemConfig[];
  performance: ProfileItemConfig[];
  skills: ProfileItemConfig[];
}

export function mapEmployeeToProfileSections(data: EmployeeDetailsResponse): ProfileSectionConfig {
  return {
    about: [
      {
        label: 'Employee PSID',
        value: data.employeeId || 'N/A'
      },
      {
        label: 'Email ID',
        value: data.email || 'N/A'
      },
      {
        label: 'Location',
        value: data.location || 'N/A'
      },
      {
        label: 'Total Experience',
        value: data.totalExperience ? `${data.totalExperience} ` : 'N/A'
      },
      {
        label: 'DOJ',
        value: data.dateOfJoining ? formatDate(data.dateOfJoining) : 'N/A'
      }
    ],
    teamInfo: [
      {
        label: 'LOB',
        value: data.lob || 'N/A'
      },
      {
        label: 'Reports To',
        value: data.reportsTo || 'N/A'
      },
      {
        label: 'L3 Leader',
        value: Array.isArray(data.l3Leader) ? data.l3Leader.join(', ') : (data.l3Leader || 'N/A')
      },
      {
        label: 'Project',
        value: data.project || 'N/A'
      },
    ],
    performance: [
      {
        label: 'Critical Resource',
        value: data.criticalResource || 'N/A'
      },
      {
        label: 'Last Spot Award',
        value: data.lastSpotAward ? formatDate(data.lastSpotAward) : 'N/A'
      },
    ],
    skills: [
      {
        label: 'Primary Skills',
        value: data.primarySkills || 'N/A'
      },
      {
        label: 'Secondary Skills',
        value: data.secondarySkills || 'N/A'
      },
      {
        label: 'Certifications',
        value: data.certifications || 'N/A'
      },
    ]
  };
}

function formatDate(dateString: string): string {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  } catch {
    return dateString;
  }
}
